import request from "@/utils/request"

//获取分支箱参数配置
export function Get_BrandBox_ParamConfigById(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerBranchBox/GetSetParamByBranchBoxId",
    method: "get",
    params
  })
}

///保存分支箱参数模型
export function Save_BrandBox_ParamConfig(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerBranchBox/SaveSetParam",
    method: "post",
    data
  })
}

///推送分支箱参数模型
export function Push_BrandBox_ParamConfig(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerBranchBox/PushSetParam",
    method: "post",
    data
  })
}

//获取分支箱计费模型
export function Get_BrandBox_ChargingConfigById(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerBranchBox/GetChargingConfigById",
    method: "get",
    params
  })
}
///保存分支箱计费模型
export function Save_BrandBox_ChargingConfig(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerBranchBox/SaveChargingConfig",
    method: "post",
    data
  })
}
//发送分支箱计费模型
export function Push_BrandBox_ChargingConfig(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerBranchBox/PushChargingConfig",
    method: "post",
    data
  })
}

//获取费控表计费模型
export function Get_FeeTable_ChargingConfigById(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerBranchBox/FeeTable_GetChargingConfigById",
    method: "get",
    params
  })
}
///保存费控表计费模型
export function Save_FeeTable_ChargingConfig(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerBranchBox/FeeTable_SaveChargingConfig",
    method: "post",
    data
  })
}
//发送费控表计费模型
export function Push_FeeTable_ChargingConfig(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerBranchBox/FeeTable_PushChargingConfig",
    method: "post",
    data
  })
}

//保存费控表信息
export function Save_BrandBox_SaveFeeTableInfo(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerBranchBox/SaveFeeTableInfo",
    method: "post",
    data
  })
}

//绑定费控表地址/修改费控表地址
export function Push_BrandBox_FeeTableAddress(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerBranchBox/PushFeeTableAddress",
    method: "post",
    data
  })
}

//绑定费控表地址/修改费控表地址
export function Push_BrandBox_QueryFeeTableInfo(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerBranchBox/PushQueryFeeTableAddress",
    method: "post",
    data
  })
}

//电表底值对齐
export function Push_BrandBox_SendFeeTableMeterDq(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerBranchBox/SendFeeTableMeterDq",
    method: "post",
    data
  })
}

//绑定费控表地址/修改费控表地址
export function Push_BrandBox_FeeTableLock(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerBranchBox/FeeTableLock",
    method: "post",
    data
  })
}
